import { FC, ReactNode, useState } from "react";
import { useTranslation } from "react-i18next";
import CustomPopup from "../../../../custom-components/CustomPopup";

interface DeleteApplicationProps {
    buttonElement: ReactNode;
    deleteApplicationHandler: () => Promise<void>;
}

const DeleteApplication: FC<DeleteApplicationProps> = (props) => {
    const [isVisible, setIsVisible] = useState(false);
    const { t } = useTranslation();

    return (
        <CustomPopup
            isVisible={isVisible}
            setIsVisible={setIsVisible}
            wrapClassName="dmin2:min-w-[628px] di6:min-w-[428px] ti6:min-w-[428px] ti7:min-w-[340px] tmax4:min-w-[340px]"
            confirmTitle={t("common.yes")}
            confirmHandler={props.deleteApplicationHandler}
            confirmButtonClassName="bg-transparent hover:bg-transparent w-[65px] dmax2:w-[47px] h-[50px] dmax2:h-[40px] mr-8 dmax2:mr-6 mt-8 dmax2:mt-6"
            cancelTitle={t("common.no")}
            cancelButtonClassName="w-[65px] dmax2:w-[47px] h-[50px] dmax2:h-[40px] mt-8 dmax2:mt-6"
            buttonElement={<div onClick={() => setIsVisible(true)}>{props.buttonElement}</div>}
        >
            <p className="H20 dmax2:H16 text-textWhite text-center mt-[10px] dmin2:max-w-[420px] di6:max-w-[340px] ti6:max-w-[340px] ti7:max-w-[280px] tmax4:max-w-[280px] break-words">
                {t("work.deletionAssurance")}
            </p>
        </CustomPopup>
    );
};

export default DeleteApplication;
